/* ==========================================================================
   Karchir — koleksiyon sayfası davranışları

   1) "Filtreler" hapı: basınca yan panel kapanıyor, ürün ızgarası tüm
      genişliğe yayılıyor. Pebble'da da aynı: panel gizleniyor, ızgara
      sütun sayısını korurken kartlar büyüyor.
   2) Fiyat sürgüsü: Horizon'da yalnız iki kutu var, Pebble'da kutuların
      üstünde çift tutamaklı bir sürgü de var. Sürgü sadece görsel bir
      parça — değerleri Horizon'un kendi kutularına yazıp "change" olayını
      tetikliyor, filtreleme işini yine Horizon yapıyor.

   Horizon filtreleme sonrası bölümü yeniden basıyor; bu yüzden her iki
   parça da DOM değişiminde yeniden kuruluyor (kurulum tekrarlanabilir).
   ========================================================================== */

(() => {
  'use strict';

  const DURUM_ANAHTAR = 'karchir-filtre-gizli';
  function depoOku(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  /* ---------------------------------------------------------------- yardımcı */

  /** "1,200.00" / "1.200,00" gibi biçimli yazıyı sayıya çevirir. */
  function sayiyaCevir(metin) {
    if (metin == null) return null;
    const temiz = String(metin).replace(/[^\d.,-]/g, '').trim();
    if (temiz === '') return null;

    const sonNokta = temiz.lastIndexOf('.');
    const sonVirgul = temiz.lastIndexOf(',');
    let ondalik = '';

    if (sonNokta > -1 && sonVirgul > -1) {
      ondalik = sonNokta > sonVirgul ? '.' : ',';
    } else if (sonVirgul > -1) {
      // Tek ayraç var: sağında 1-2 hane varsa ondalık, değilse binlik
      ondalik = temiz.length - sonVirgul <= 3 ? ',' : '';
    } else if (sonNokta > -1) {
      ondalik = temiz.length - sonNokta <= 3 ? '.' : '';
    }

    let ham = temiz;
    if (ondalik === ',') {
      ham = temiz.replace(/\./g, '').replace(',', '.');
    } else if (ondalik === '.') {
      ham = temiz.replace(/,/g, '');
    } else {
      ham = temiz.replace(/[.,]/g, '');
    }

    const n = parseFloat(ham);
    return Number.isFinite(n) ? n : null;
  }

  /* ------------------------------------------------- 1) filtre panelini gizle */

  function filtreDurumuUygula() {
    const gizli = depoOku(DURUM_ANAHTAR) === '1';

    document.querySelectorAll('.collection-wrapper').forEach((sarmal) => {
      sarmal.classList.toggle('karchir-filtresiz', gizli);
    });

    document.querySelectorAll('[data-karchir-filtre-ac]').forEach((btn) => {
      btn.setAttribute('aria-expanded', gizli ? 'false' : 'true');
    });
  }

  document.addEventListener('click', (olay) => {
    const btn = olay.target.closest('[data-karchir-filtre-ac]');
    if (!btn) return;

    olay.preventDefault();
    const gizli = depoOku(DURUM_ANAHTAR) === '1';
    try {
      sessionStorage.setItem(DURUM_ANAHTAR, gizli ? '0' : '1');
    } catch (e) {
      /* gizli sekmede depolama kapalı olabilir */
    }
    filtreDurumuUygula();
  });

  /* ------------------------------------------------------- 2) fiyat sürgüsü */

  function surguKur(bilesen) {
    if (bilesen.dataset.karchirSurgu === '1') return;

    const kutular = bilesen.querySelectorAll('input.price-facet__input');
    if (kutular.length !== 2) return;

    const altKutu = kutular[0];
    const ustKutu = kutular[1];

    const enBuyuk = sayiyaCevir(ustKutu.getAttribute('data-max')) ?? sayiyaCevir(ustKutu.placeholder);
    if (!enBuyuk || enBuyuk <= 0) return;

    bilesen.dataset.karchirSurgu = '1';

    const sarmal = document.createElement('div');
    sarmal.className = 'karchir-surgu';
    sarmal.innerHTML =
      '<span class="karchir-surgu__ray"></span><span class="karchir-surgu__dolu"></span>' +
      '<input type="range" class="karchir-surgu__alt" min="0" step="1" aria-label="En düşük fiyat">' +
      '<input type="range" class="karchir-surgu__ust" min="0" step="1" aria-label="En yüksek fiyat">';

    const alt = sarmal.querySelector('.karchir-surgu__alt');
    const ust = sarmal.querySelector('.karchir-surgu__ust');
    const dolu = sarmal.querySelector('.karchir-surgu__dolu');

    alt.max = String(Math.ceil(enBuyuk));
    ust.max = String(Math.ceil(enBuyuk));
    alt.value = String(sayiyaCevir(altKutu.value) ?? 0);
    ust.value = String(sayiyaCevir(ustKutu.value) ?? Math.ceil(enBuyuk));

    bilesen.insertBefore(sarmal, bilesen.firstChild);

    const ciz = () => {
      const a = Number(alt.value);
      const u = Number(ust.value);
      const sol = (a / enBuyuk) * 100;
      const sag = (u / enBuyuk) * 100;
      dolu.style.insetInlineStart = sol + '%';
      dolu.style.width = Math.max(0, sag - sol) + '%';
      // Tur 142: ekran okuyucu yalın sayı yerine "650 TL" duysun
      alt.setAttribute('aria-valuetext', a + ' TL');
      ust.setAttribute('aria-valuetext', u + ' TL');
    };

    const kutularaYaz = () => {
      const a = Number(alt.value);
      const u = Number(ust.value);
      altKutu.value = a > 0 ? String(a) : '';
      ustKutu.value = u < Math.ceil(enBuyuk) ? String(u) : '';
    };

    const duzelt = (hangi) => {
      let a = Number(alt.value);
      let u = Number(ust.value);
      if (a > u) {
        if (hangi === 'alt') {
          a = u;
          alt.value = String(a);
        } else {
          u = a;
          ust.value = String(u);
        }
      }
      ciz();
      kutularaYaz();
    };

    alt.addEventListener('input', () => duzelt('alt'));
    ust.addEventListener('input', () => duzelt('ust'));

    // Tutamak bırakılınca Horizon'un kendi filtreleme akışı tetikleniyor
    const uygula = () => {
      ustKutu.dispatchEvent(new Event('change', { bubbles: true }));
    };
    alt.addEventListener('change', uygula);
    ust.addEventListener('change', uygula);

    // Kutulara elle yazılırsa sürgü onları takip etsin
    const kutudanOku = () => {
      alt.value = String(sayiyaCevir(altKutu.value) ?? 0);
      ust.value = String(sayiyaCevir(ustKutu.value) ?? Math.ceil(enBuyuk));
      ciz();
    };
    altKutu.addEventListener('change', kutudanOku);
    ustKutu.addEventListener('change', kutudanOku);

    ciz();
  }

  /* --------------------------------------------------------- 3) beden süzme

     Mağazada gerçek beden filtresi açık olmadığı için (ölçüldü:
     filter.v.option.beden URL'i Shopify tarafından yok sayılıyor) süzmeyi
     tema yapıyor: her kartın üstünde bedenleri yazıyor, seçilen bedene
     uymayan kartlar gizleniyor.

     Seçim adres çubuğunda (?beden=…, paylaşılabilsin) ve bu sayfa
     açılışı boyunca bellekte (Horizon başka bir filtreden sonra bölümü
     yeniden basınca kaybolmasın) tutuluyor.

     Tur 145: eskiden oturum belleğinde (sessionStorage) tutuluyordu; müşteri
     aynı sayfaya menüden yeniden gelince seçim GÖRÜNMEDEN uygulanıyor,
     "Tüm Ürünler"de 36 yerine 4 ürün çıkıyordu. Artık yeni açılışta yalnız
     adresteki seçim geçerli. */

  /** @type {string | null} bu sayfa açılışındaki seçim */
  let bedenSecimi = null;

  function bedenOku() {
    if (bedenSecimi == null) {
      bedenSecimi = new URLSearchParams(location.search).get('beden') || '';
    }
    return bedenSecimi.split(',').map((x) => x.trim()).filter(Boolean);
  }

  function bedenYaz(deger, adresiGuncelle) {
    bedenSecimi = deger;

    if (adresiGuncelle === false) return;

    const adres = new URL(location.href);
    if (deger) {
      adres.searchParams.set('beden', deger);
    } else {
      adres.searchParams.delete('beden');
    }
    history.replaceState(null, '', adres);
  }

  function bedenUygula() {
    const secili = bedenOku();

    document.querySelectorAll('[data-karchir-beden-kutu]').forEach((kutu) => {
      kutu.checked = secili.indexOf(kutu.value) > -1;
    });

    const kartlar = document.querySelectorAll('.product-grid > li[data-karchir-beden]');
    if (!kartlar.length) return;

    let gorunen = 0;
    kartlar.forEach((kart) => {
      const sahip = (kart.getAttribute('data-karchir-beden') || '').split('|').filter(Boolean);
      const uyar = secili.length === 0 || secili.some((b) => sahip.indexOf(b) > -1);
      kart.hidden = !uyar;
      if (uyar) gorunen += 1;
    });

    // "8 ürün" yazısı seçime göre güncelleniyor
    document.querySelectorAll('.products-count-wrapper [role="status"]').forEach((el) => {
      if (!el.dataset.karchirTaban) el.dataset.karchirTaban = el.textContent.trim();
      const yeni = secili.length
        ? el.dataset.karchirTaban.replace(/\d+/, String(gorunen))
        : el.dataset.karchirTaban;
      if (el.textContent !== yeni) el.textContent = yeni;
    });

    // Hiç kart kalmadıysa kısa bir bilgi satırı
    const izgara = document.querySelector('.product-grid');
    let bos = document.querySelector('.karchir-beden-bos');
    if (secili.length && gorunen === 0) {
      if (!bos && izgara) {
        bos = document.createElement('p');
        bos.className = 'karchir-beden-bos';
        bos.textContent = 'Seçtiğin bedende ürün yok.';
        izgara.parentNode.insertBefore(bos, izgara.nextSibling);
      }
    } else if (bos) {
      bos.remove();
    }
  }

  document.addEventListener('change', (olay) => {
    const kutu = olay.target.closest && olay.target.closest('[data-karchir-beden-kutu]');
    if (!kutu) return;

    // Horizon bu değişikliği görüp sunucuya gitmesin — süzme bizde
    olay.stopPropagation();

    // Aynı beden hem yan panelde hem mobil çekmecede var. Bu yüzden
    // "işaretli olanları topla" yerine, DEĞİŞEN kutunun durumu seçime
    // ekleniyor/çıkarılıyor — yoksa ikizi seçimi geri açıyor.
    const secili = bedenOku().filter((v) => v !== kutu.value);
    if (kutu.checked) secili.push(kutu.value);

    bedenYaz(secili.join(','), true);
    bedenUygula();
  }, true);

  try {
    Object.keys(sessionStorage).forEach((k) => { if (k.indexOf('karchir-beden:') === 0) sessionStorage.removeItem(k); });
  } catch (e) {
    /* depolama kapalı olabilir */
  }

  function kur() {
    filtreDurumuUygula();
    document.querySelectorAll('price-facet-component').forEach(surguKur);
    bedenUygula();
  }


  /* 4) kart görselini geri alma KALDIRILDI (Batuhan 16 Eyl): fare karttan
     çıkınca görsel başa dönmesin, oklarla gelinen görselde kalsın. */

  /* ------------------------------------------------------------ başlat + izle */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }

  let zamanlayici = null;
  const izleyici = new MutationObserver(() => {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(() => { kur(); izleyici.takeRecords(); }, 80);
  });

  const izlemeyeBasla = () => {
    const hedef = document.querySelector('results-list') || document.body;
    izleyici.observe(hedef, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', izlemeyeBasla);
  } else {
    izlemeyeBasla();
  }
})();
